import { Button, Grid, TextField } from "@material-ui/core";
import React, { useState } from "react";
import "./AdminInstallation.css";
function AdminInstallation(props) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [documents, setDocuments] = useState([]);
  const [thumbnail, setThumbnail] = useState(null);

  const handleChage = (e) => {
    if (e.target.name === "title") {
      setTitle(e.target.value);
    } else if (e.target.name === "description") {
      setDescription(e.target.value);
    } else if (e.target.name === "thumbnail") {
      setThumbnail(e.target.files[0]);
    } else if (e.target.name === "documents") {
      setDocuments(e.target.files);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(documents, title, description, thumbnail);

    // if (thumbnail !== null) {

    //     var storageRef = storage.ref();
    //     var spaceRef = storageRef.child(`images/${thumbnail['name']}`)
    //     spaceRef.put(inputFile)
    //         .then(async res => {
    //             db.collection('Questions').add({
    //                 "title": title,
    //                 "description": description,
    //
    //                 "thumbnailImgUrl": await spaceRef.getDownloadURL(),
    //
    //             }).then((res) => {
    //                 console.log('response after ading', res);
    //                 setFlag(true)
    //             }).catch(err => {
    //                 console.log('error while adding question ', err);
    //             })
    //         })
    //         .catch(err => {
    //             console.log('error while uploading', err);
    //         })

    // } else {
    //     db.collection('Questions').add({
    //         "question": question,
    //         "technology": technology,
    //         "askedBy": [{
    //             "userName": sessionStorage.getItem('userName'),
    //             "emailId": sessionStorage.getItem('emailId'),
    //             "profileImageUrl": sessionStorage.getItem('imgUrl')
    //         }],
    //         "imgUrl": "",
    //         "answers": [{
    //             "answerBy": "",
    //             "answer": "",
    //             "imgUrl": ""
    //         }]
    //     }).then((res) => {
    //         console.log('response after ading', res);
    //         swal("Question added sucessfully!", "Wait for someone to answer", "success");

    //         setFlag(true)
    //     }).catch(err => {
    //         console.log('error while adding question ', err);
    //     })
    // }
  };
  return (
    // a- indicated admin in css variables
    <div>
      <div>
        <form onSubmit={handleSubmit} className="a-install-upload-form">
          <h1 style={{ textAlign: "center" }}>Add Installation Guide</h1>
          <Grid container spacing="2">
            <Grid item sm={12} xs={12}>
              <TextField
                id="outlined-basic"
                label="Title"
                variant="outlined"
                name="title"
                onChange={handleChage}
                fullWidth
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <TextField
                id="outlined-basic"
                label="Description"
                variant="outlined"
                name="description"
                onChange={handleChage}
                fullWidth
              />
            </Grid>
            {/* <Grid item sm={12} xs={12}>

                            <TextField id="outlined-basic" inputProps={{ multiple: true }} variant="outlined" name="documents" type="file" onChange={handleChage} fullWidth /></Grid> */}
            <Grid item sm={12} xs={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                name="thumbnail"
                type="file"
                onChange={handleChage}
                fullWidth
              />
            </Grid>
            <Button
              type="submit"
              variant="outlined"
              className="add-question-btn"
            >
              Submit
            </Button>
          </Grid>
        </form>
      </div>
    </div>
  );
}

export default AdminInstallation;
